import {CsvConfiguration} from './CsvConfiguration';
import {XmlConfiguration} from './XmlConfiguration';

export class FileConfiguration {
checkFileExtension: boolean | null;
compressedFileFormat: string[];
compressionFileSize: number | null;
csvConfig: CsvConfiguration;
delay: number | null;
errorPath: string;
extension: string;
fileFormat: string;
historyPath: string;
mostRecentFile: boolean | null;
name: string;
path: string[];
today: boolean | null;
tsFileFormat: string;
witnessFileExtension: string;
xmlConfig: XmlConfiguration;
}

